import { useEffect, useState } from 'react'
import { TimetablesTab } from '@/components/timetable-import'
import { TimetableImportPage } from '@/pages/TimetableImportPage'
import { timetableApi, type AdminPlanRights } from '@/services/api/timetable'

export function TimetableManagementPage() {
  return (
    <div className="p-6 max-w-full">
      <div className="bg-white rounded-lg border p-6">
        <TimetablesTab showLoadLink />
      </div>
    </div>
  )
}

export function AdminTimetableLoadPage() {
  const [rights, setRights] = useState<AdminPlanRights | null>(null)
  useEffect(() => {
    timetableApi.adminRights().then(setRights).catch(() => setRights({ load: false, delete: false, edit: false }))
  }, [])
  if (!rights) return <div className="p-6 text-sm text-gray-500">Rechte werden geladen…</div>
  if (!rights.load) return <div className="p-6 text-sm text-gray-700">Laden ist für den Admin verborgen.</div>
  return <TimetableImportPage loadOnly />
}
